import { Component } from '@angular/core';
import {AppDetailsDialogComponent} from '../dialogs/app-details-dialog/app-details-dialog.component';
import {AppDetailsService} from '../../services/app.details.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProgressService} from '../../services/progress.service';

@Component({
  selector: 'about-link',
  template: '<a class="about-hidden" (click)="openAppDetailsModal()">About</a>',
})
export class AboutLinkComponent {
  constructor(
    public modalService: NgbModal,
    private appDetailsService: AppDetailsService,
    private progressService: ProgressService,
  ) {

  }

  openAppDetailsModal() {
    const appDetailsModal = this.modalService.open(AppDetailsDialogComponent, {windowClass: 'about-modal'});
    this.appDetailsService.getFundraisingToolsAppDetails().subscribe(response => {
      appDetailsModal.componentInstance.fundraisingToolsApp = response;
      this.progressService.stopProgress(false);
    });
    this.appDetailsService.getLogicalAPIAppDetails().subscribe(response => {
      appDetailsModal.componentInstance.logicalApiApp = response;
      this.progressService.stopProgress(false);
    });

  }
}
